"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const EmptyInfo = ({ primary, secondary }) => {
    return (react_1.default.createElement(index_1.Card, { variant: "outlined", sx: { py: 4 } },
        react_1.default.createElement(index_1.CardContent, null,
            react_1.default.createElement(index_1.Typography, { variant: "body1", color: "textSecondary", align: "center" }, primary),
            secondary && (react_1.default.createElement(index_1.Box, { mt: 3 }, typeof secondary === 'string' ? (react_1.default.createElement(index_1.Typography, { color: "textSecondary", variant: "body2", align: "center" }, secondary)) : (react_1.default.createElement(index_1.Box, { textAlign: "center" }, secondary)))))));
};
exports.default = EmptyInfo;
